export default class Armazem {
  constructor(id, descricao, codigo, estado, quantidade, observacao) {
    this.id = id;
    this.descricao = descricao;
    this.codigo = codigo;
    this.estado = estado;
    this.quantidade = quantidade;
    this.observacao = observacao;
  }

  update(armazem) {
    this.id = armazem.id;
    this.descricao = armazem.descricao;
    this.codigo = armazem.codigo;
    this.estado = armazem.estado;
    this.quantidade = armazem.quantidade;
    this.observacao = armazem.observacao;
  }
}
